import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScPromoDot = styled.span`
  position: relative;
  align-self: stretch;
  width: 0;
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    top: 9px;
    left: -1px;
    width: 5px;
    height: 5px;
    background-color: ${({ theme }) => theme.mainColor};
    border-radius: 50%;
    @media (${device.mobile}) {
      top: 1px;
      left: -14px;
      width: 5px;
      height: 5px;
    }
  }
`;

export const ScBonusReceivedTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .title {
    font-weight: 700;
  }

  .text {
    margin: 0;
  }

  .link {
    font-weight: 600;
    text-decoration: underline;
    transition: opacity 0.3s;

    @media (hover: hover) {
      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
